import React from 'react';

const base = {
  width: 20,
  height: 20,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const IconHome = (p) => (
  <svg {...base} {...p}>
    <path d="M3 11l9-7 9 7" />
    <path d="M5 10v10h14V10" />
  </svg>
);

export const IconTrophy = (p) => (
  <svg {...base} {...p}>
    <path d="M8 4h8v6a4 4 0 01-8 0V4z" />
    <path d="M8 5H4v2a4 4 0 004 4M16 5h4v2a4 4 0 01-4 4" />
    <path d="M12 14v4M9 21h6M10 18h4" />
  </svg>
);

export const IconUsers = (p) => (
  <svg {...base} {...p}>
    <circle cx="9" cy="8" r="3.2" />
    <path d="M3.5 20a5.5 5.5 0 0111 0" />
    <circle cx="17" cy="9" r="2.6" />
    <path d="M15 20a4.5 4.5 0 016.5-4" />
  </svg>
);

export const IconAcademy = (p) => (
  <svg {...base} {...p}>
    <path d="M3 10l9-5 9 5-9 5-9-5z" />
    <path d="M7 12.5V17c0 1.4 2.2 2.5 5 2.5s5-1.1 5-2.5v-4.5M20 10v6" />
  </svg>
);

export const IconTag = (p) => (
  <svg {...base} {...p}>
    <path d="M3 11.5V5a2 2 0 012-2h6.5L21 12.5 12.5 21 3 11.5z" />
    <circle cx="8" cy="8" r="1.4" fill="currentColor" stroke="none" />
  </svg>
);

export const IconScale = (p) => (
  <svg {...base} {...p}>
    <path d="M12 3v18M6 8h12M6 8L3 15h6L6 8zM18 8l-3 7h6l-3-7z" />
  </svg>
);

export const IconBracket = (p) => (
  <svg {...base} {...p}>
    <path d="M4 5h4v4H4zM4 15h4v4H4zM12 7v10M8 7h4M8 17h4M12 12h5M17 12v-5h-5M17 12v5h-5" />
  </svg>
);

export const IconBolt = (p) => (
  <svg {...base} {...p}>
    <path d="M13 2L4 14h6l-1 8 9-12h-6l1-8z" />
  </svg>
);

export const IconChart = (p) => (
  <svg {...base} {...p}>
    <path d="M4 20V10M11 20V4M18 20v-7" />
    <path d="M2 20h20" />
  </svg>
);

export const IconUser = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="8" r="3.6" />
    <path d="M4.5 20a7.5 7.5 0 0115 0" />
  </svg>
);

export const IconWallet = (p) => (
  <svg {...base} {...p}>
    <path d="M3 7a2 2 0 012-2h12a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V7z" />
    <path d="M17 12h2v3h-2a1.5 1.5 0 010-3z" />
    <path d="M3 8h14" />
  </svg>
);
